export const RETRY_MFA_REQUEST_COUNTDOWN_SECONDS = 30;
